import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import axios from 'axios';
import { AppFile } from '@dill/dill-shared';
import { BASE_API_URL } from '../../utils/constants';
import { myFirebaseAuth } from '../../firebase/config';
import { logoutUser } from './authService';

export const createDispute = createAsyncThunk(
  'disputes/createDispute',
  async (
    {
      supplierId,
      buyerId,
      invoiceId,
      invoiceNumber,
      invoiceSalesRepName,
      disputeReason,
      disputeNotes,
      disputeAttachments,
    }: {
      supplierId: string;
      buyerId: string;
      invoiceId?: string | null;
      invoiceNumber?: string | null;
      invoiceSalesRepName?: string | null;
      disputeReason: string;
      disputeNotes?: string | null;
      disputeAttachments?: AppFile[];
    },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.post<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/disputes/createDispute`,
        {
          buyerId,
          invoiceId,
          invoiceNumber,
          invoiceSalesRepName,
          disputeReason,
          disputeNotes,
          disputeAttachments,
        },
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const getSupplierDisputes = createAsyncThunk(
  'disputes/getSupplierDisputes',
  async ({ supplierId, buyerId }: { supplierId: string; buyerId?: string }, thunkApi) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const params = new URLSearchParams();
      if (buyerId) {
        params.append('buyerId', buyerId);
      }
      const response = await axios.get<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/disputes/getSupplierDisputes?${params.toString()}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const getSupplierOpenDisputesCount = createAsyncThunk(
  'disputes/getSupplierOpenDisputesCount',
  async ({ supplierId }: { supplierId: string }, thunkApi) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.get<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/disputes/getSupplierOpenDisputesCount`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const updateDispute = createAsyncThunk(
  'disputes/updateDispute',
  async (
    {
      supplierId,
      disputeId,
      isResolved,
    }: { supplierId: string; disputeId: string; isResolved: boolean },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.put<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/disputes/${disputeId}/updateDispute`,
        { isResolved },
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);
